import { useState, useContext, memo } from "react";
import { createPortal } from 'react-dom';
import File from "./File";
import { Modal } from "react-bootstrap";
import { BrowserContext } from "../services/BrowserContext";


const Video = (props)=>{
    const {itemsManipulator} = useContext(BrowserContext);
    const [show, setShow] = useState(false);
    const [thumbError, setThumbError] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // Affiche Jellyfin si le dossier est tagué et que le film a une correspondance.
    // URL signée (le session_id n'apparaît plus dans l'URL).
    const jellyfinSrc = props.jellyfinId
        ? itemsManipulator.jellyfinImageUrl(props.jellyfinId, props.jfExp, props.jfSig)
        : null;

    return (
        <>
        <File onDoubleClick={handleShow} {...props}><File.Ico>
            {(jellyfinSrc && !thumbError)
                ? <img src={jellyfinSrc} alt={props.name} onError={() => setThumbError(true)} style={{width:'30px', height:'44px', objectFit:'cover', borderRadius:'4px', marginRight:'5px'}}/>
                : <i className="bi bi-film fs-4 me-1"></i>
            }
        </File.Ico></File>
        {show && createPortal(
            <Modal centered show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{props.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <video className="w-100" controls>
                        <source src={itemsManipulator.signedDownloadUrl(props.path, props.name, props.dlExp, props.dlSig)}/>
                        Your browser does not support the video tag.
                    </video>
                </Modal.Body>
                
            </Modal>,
            document.body
        )}
        </>
    );

}
export default memo(Video)